import Form from './modules/form';
import Sliders from './modules/sliders';
import Nav from './modules/nav';
import SearchInput from './modules/input-search';
import Gallery  from './modules/gallery';
//import Counter from './modules/counter';
import ProductCard from './modules/product-card';
import Select from './modules/select';
import CatalogFilter from './modules/catalog-filter';
//import View from './modules/view';
//import CardDetail from './modules/card-detail';
import ProductDetails from './modules/product-details';

(() => {
  Nav.init();
  SearchInput.init();
  Sliders.initAll();
  ProductCard.init();
  //View.init();
  Select.init();
  // Counter.init();
  Gallery.initAll();
  Form.init();
  CatalogFilter.init();
  // CardDetail.init();
  ProductDetails.init();
})();
